/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMutation } from 'data-fetching-client';
import { addAlert } from '../../utils/alerts';
import { useTracker } from '../../utils/usageTracker';
import { PAUSE_SUBSCRIPTION } from './pauseSubscriptionApi';
import { jsx as _jsx } from "react/jsx-runtime";
export function usePauseSubscription({
  objectId,
  internalNotes,
  onClose
}) {
  const {
    trackPauseChange
  } = useTracker();
  return useMutation(PAUSE_SUBSCRIPTION, {
    variables: {
      objectId,
      pauseReason: internalNotes
    },
    fetchPolicy: 'network-only',
    onError: async () => {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.errorPausingTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.errorPausingMessage"
        }),
        type: 'danger'
      });
      await onClose();
    },
    onCompleted: async () => {
      trackPauseChange({
        subType: 'pause',
        action: 'pauseSubscriptionModalSubmitted',
        status: 'PAUSED'
      });
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.successfullyPausedTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.successfullyPausedMessage"
        }),
        type: 'success'
      });
      await onClose();
    }
  });
}